import React, { useContext } from "react";
import Header from "../../../homepage/components/SectionHeader";
import ListCard from "./components/servers-card/servers-list.container";
import CardPreviewComponent from "./components/servers-card/servers-card.preview";
import { useHistory } from "react-router-dom";
import { I8nContext } from "../../../../../libs/i18n";
import {
  MainStructure, 
  ContainerPreview, 
  CardTitle, 
  CardContentPreview, 
} from "app/views/sections/components/layout";
import styled from "styled-components";
import ServersMobileView from "./components/server-mobile/servers.mobile";

const CustomCardContentPreview = styled(CardContentPreview)`
  @media (min-width: 640px) {
    height: calc(16rem + 150px);
  }
  @media (min-width: 1024px) {
    height: calc(16vh + 150px);
  }
  flex-grow: 1;
`;

const ServersSummaryPreview: React.FC = () => {

  const history = useHistory();
  const handleRoute = () => history.push("/servers-summary");
  const { translate } = useContext(I8nContext);

  return (
    <div onClick={handleRoute} className='box'>
      <Header title={translate("SERVICE_SUMMARY")} />
      <MainStructure>
          <div className="mobile">
            <ServersMobileView />
          </div>
          <div className="desktop">
            <ContainerPreview>
              <CardTitle>
                <p style={{width: "30%"}}>{translate("SERVICE")}</p>
                <p style={{width: "15%"}}>{translate("GUEST_COUNT")}</p>
                <p style={{width: "20%"}}>{translate("AVG_TICKET")}</p>
                <p style={{width: "20%"}}>{translate("TOTAL_SALES")}</p>
                <p style={{width: "15%"}}>{translate("RATING")}</p>
              </CardTitle>
              <CustomCardContentPreview> 
                <ListCard Component={CardPreviewComponent} />  
              </CustomCardContentPreview>
            </ContainerPreview>
          </div>
        </MainStructure>
      </div>
  );
};

export default ServersSummaryPreview;
